import { render, staticRenderFns } from "./qianhai.vue?vue&type=template&id=a6da24a6&scoped=true&"
import script from "./qianhai.vue?vue&type=script&lang=js&"
export * from "./qianhai.vue?vue&type=script&lang=js&"
import style0 from "./qianhai.vue?vue&type=style&index=0&id=a6da24a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6da24a6",
  null
  
)

export default component.exports